import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './auth.module.scss'

import { sendVerificationCode, verifyEmail } from '../../features/authSlice.js'
import { LoadingSpinner } from '../../components/loadingSpinner/LoadingSpinner'
import AuthCommonCard from '../../components/molecules/AuthCommonCard.jsx'
import AuthCommonForm from '../../components/molecules/AuthCommonForm.jsx'
import ButtonCustom from '../../components/atoms/button/ButtonCustom.jsx'
import { CooldownButton } from '../../components/buttons/CooldownButton.jsx'

export const EmailConfirmationPage = () => {
	const dispatch = useDispatch()
	const user = useSelector((state) => state.auth.user)
	const loading = useSelector((state) => state.auth.loading)

	const [verificationCode, setVerificationCode] = useState('')

	const handleSubmit = async (e) => {
		e.preventDefault()
		dispatch(
			verifyEmail({
				email: user?.email,
				verificationCode: verificationCode,
			})
		)
	}

	return (
		<>
			<AuthCommonCard className={styles.signUpSection}>
				<AuthCommonForm
					title={'Verify Your Email'}
					subTitle={
						<>
							We sent a code to <strong>{user?.email}</strong>
						</>
					}
				>
					<form onSubmit={handleSubmit}>
						<input
							autoFocus
							required
							maxLength={6}
							type="text"
							placeholder="Enter verification code"
							value={verificationCode}
							onChange={(e) =>
								setVerificationCode(e.target.value)
							}
						/>
						<ButtonCustom type="submit">
							{loading ? (
								<LoadingSpinner size="10px" color="#333" />
							) : (
								'Verify'
							)}
						</ButtonCustom>
                        <br/>
                        <CooldownButton
                            buttonText='Resend Verification Code'
                            cooldownSeconds={60}
                            dispatchFunction={sendVerificationCode}
                            dispatchData={user?.email}
                        />
					</form>
				</AuthCommonForm>
			</AuthCommonCard>
		</>
	)
}
